import { z } from 'zod'

export const zodParse = <T>(data: unknown, schema: z.ZodSchema<T>): T | null => {
  const result = schema.safeParse(data)

  if (!result.success) {
    console.error(`Validation failed: ${result.error}`)
    return null
  }
  return result.data
}
